import {
  QueryClient,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { useAtomValue } from "jotai";

import BrieConversationAPI from "../../../api/api/BrieConversationAPI";
import { getErrorMessage } from "../../../utils/GeneralUtils";
import { BrieGPTTabs } from "./BrieGPTSidebarElements/Types";
import { tenantIDAtom } from "../../../atoms/GlobalAtoms";
import { BrieTypeProps } from "./BrieGPTSidebar";

type Props = {
  projectName: string;
  onSuccess: (projectID: string) => void;
  onError: (err: string) => void;
} & BrieTypeProps;

export default function useCreateProject(tab: BrieGPTTabs) {
  const client = useQueryClient();
  const tenantID = useAtomValue(tenantIDAtom) || "";

  const createProject = useMutation({
    mutationFn: ({
      projectName,
      onError,
      onSuccess,
      ...brieTypeProps
    }: Props) => {
      return BrieConversationAPI.createBrieGPTProject(
        projectName,
        brieTypeProps
      ).then((res) => res?.data?.data?.project);
    },
    onSuccess: (
      project,
      { projectName, onSuccess, onError, ...brieTypeProps }
    ) => {
      if (!project) {
        return onError("An error occurred while creating the project.");
      }

      const itemID =
        brieTypeProps.type === "view"
          ? brieTypeProps.viewID
          : brieTypeProps.recordID;

      InvalidateGPTProjectQueries({
        tab,
        tenantID,
        itemID,
        client,
      });
      onSuccess(project._id);
    },
    onError: (err, { onError }) => {
      onError(getErrorMessage(err));
    },
  });

  return {
    createProject: createProject.mutate,
    creating: createProject.isPending,
  };
}

export function InvalidateGPTProjectQueries({
  tab,
  tenantID,
  itemID,
  client,
}: {
  tab: BrieGPTTabs;
  tenantID: string;
  /** ViewID or RecordID */
  itemID: string;
  client: QueryClient;
}) {
  console.log({ tab, itemID });
  if (["Personal", "All"].includes(tab)) {
    console.log("Invalidating Personal and All", tab, itemID);
    client.refetchQueries({
      queryKey: [tenantID, itemID, "BrieGPTProjects", "Personal"],
    });
    client.refetchQueries({
      queryKey: [tenantID, itemID, "BrieGPTProjects", "All"],
    });

    return;
  }

  client.refetchQueries({
    queryKey: [tenantID, itemID, "BrieGPTProjects", tab],
  });
}
